<template>
  <div id="sqWrap" ref="sqWrap">
    <div
      class="sqlist"
      :style="{ height: sqlistHeight + 'px' }"
      v-show="jsLists.length != 0"
    >
      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="disabled"
        infinite-scroll-distance="100"
      >
        <div class="item" v-for="(item,i) in jsLists" :key="i">
          <div class="left">
            <div class="top clearfix">
              <p class="name">{{ item.department }}</p>
              <p class="phone" @click="call(item.contact)">{{ item.contact }}</p>
            </div>
            <p
              class="address"
              @click="intoappMap(item.lng, item.lat, item.address)"
            >
              {{ item.mapAddress }}{{ item.address }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="isfoot" v-show="isFoot"> 我已经到底了...</div>
    <div class="noLists" v-show="tzshow&&jsLists.length==0">
        <img src="~@/assets/imgs/bg.png" alt="">
        <p>这里空空如也~</p>
    </div>
  </div>
</template>

<script>
import Top from "@/component/top/top";
import axios from "axios";
import { Toast, Indicator } from "mint-ui";
export default {
  data() {
    return {
      jsLists: [],
      disabled: false,
      isFoot:false,
      tzshow:false,
      page: 1,
      sqlistHeight: document.documentElement.offsetHeight - 44
    };
  },
  components: {
    Top
  },
  created() {
    this.getLists(this.$route.query.sid);
  },
  methods: {
    getLists(id) {
      let _this = this
      Indicator.open();
      this.disabled = true;
      axios
        .get(
          `${this.commonIp()}/v1/communityInfo/index?streetId=${id}&page=${this.page}`
        )
        .then(res => {
          Indicator.close();
          if (res.data.code == 200) {
            let infos = res.data.data.infos;
            if (infos && infos.length != 0) {
              _this.jsLists = _this.jsLists.concat(res.data.data.infos);
              ++_this.page;     
              _this.disabled = false;
              _this.tzshow = false
            }else{
              if(res.data.data.infos.length == 0 && _this.page == 1){
                console.log('333')
                _this.isFoot = false;
                _this.tzshow = true
              }else{
                console.log('222')
                _this.isFoot = true;
                _this.tzshow = false
              }
            }
          } else {
            Toast(res.data.message);
          }
        })
        .catch(error => {
          Indicator.close();
          // if (obj.pageNum == 1) return
          // this.$refs.sqWrap.scrollTop = this.$refs.sqWrap.scrollTop - this.$refs.bottom.offsetHeight
          // this.disabled = false
        });
    },
    intoappMap(lng, lat, address) {
      this.isScreen(`app://map?lng=${lng}&lat=${lat}&address=${address}`);
    },
    loadMore() {
      this.disabled = true;
      this.getLists(this.$route.query.id);
    },
    // 拨打电话
    call(tel) {
      this.isScreen(`app://tel?mobile=${tel}`)
    }
  }
};
</script>

<style lang="less">
@import "~@/assets/less/index.less";
#sqWrap {
  .noLists{
    padding-top:65%;
  }
  .sqlist {
    .item {
      border-bottom: 1px solid #d8d8d8;
      padding: 15px 0 12px 15px;
      &:first-child {
        border-top: 1px solid #d8d8d8;
      }
      .left {
        padding: 0 10px 0 0;
        .top {
          margin: 0 0 2px 0;
          p {
            font-size: @ft16;
            max-width:100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color:#238dd4;
            margin:2px 0 5px 0;
            &.name {
              margin: 0 6px 0 0;
              color: @fc32;
            }
          }
        }
        .address {
          font-size: @ft12;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          background:url('~@/assets/imgs/dw22.png') no-repeat left 2px;
          background-size:11px;
          padding-left:16px;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/jdlist/jdlist.vue